import React from "react";
import RadioButton from "../../components/radio/RadioButton";
import { Control, FieldValues, useController, useWatch } from "react-hook-form";
import CheckboxGroup from "./CheckboxGroup";
import { TextareaField } from "./TextareaField";
import { checkboxesChoicesType } from "../../types/common";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface RadioFieldProps<T extends FieldValues> {
	checkboxChoices?: checkboxesChoicesType;
	control: Control<T>;
	criterionKey: string;
	inputLabel?: string;
	onUpdateField?: (criterionKey: string, radioKey: string) => void;
	radioKey: string;
	radioLabel: string;
	radioTitle?: string;
	setFocus?: (inputKey: string) => void;
	setValue?: (criterionKey: string, radioKey: string) => void;
}

export default function RadioField({
	checkboxChoices,
	criterionKey,
	control,
	inputLabel,
	onUpdateField,
	radioKey,
	radioLabel,
	radioTitle,
	setValue,
	setFocus,
}: RadioFieldProps<any>) {
	const inputKey = `${criterionKey}_${radioKey}Details`;
	const {
		field: { value, onChange },
	} = useController({
		name: criterionKey,
		control,
	});

	const radioInput = useWatch({
		control,
		name: criterionKey,
	});

	const handleFocus = () => {
		setValue && setValue(criterionKey, radioKey);
		onUpdateField && onUpdateField(criterionKey, radioKey);
	};

	return (
		<div className="radio-section">
			{radioTitle && <p className="title">{radioTitle}</p>}
			<RadioButton
				currentInput={value}
				criterionKey={criterionKey}
				id={radioKey}
				label={radioLabel}
				onInputChange={(id) => {
					onChange(id);
					onUpdateField && onUpdateField(criterionKey, id);
					setFocus && setFocus(inputKey);
				}}
			/>
			{inputLabel && (
				<TextareaField
					control={control}
					disabled={radioInput !== radioKey}
					id={inputKey}
					label={inputLabel}
					name={inputKey}
					onFocus={handleFocus}
					onInputChange={onUpdateField}
					required={radioInput === radioKey}
					rows={3}
				/>
			)}
			{checkboxChoices && (
				<CheckboxGroup
					checkboxes={checkboxChoices}
					control={control}
					disabled={radioInput !== radioKey}
					fieldKey={inputKey}
					onFocus={handleFocus}
					validate={{
						buy: (value: string[]) => {
							return (
								radioInput !== radioKey ||
								(radioInput === radioKey && value.length > 0)
							);
						},
					}}
				/>
			)}
		</div>
	);
}
